import _styled from "@emotion/styled/base";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { forwardRef, useCallback, useId, useRef, useState } from 'react';
import { Message } from '../../primitives/internal/Message/index.js';
import { Container } from '../../primitives/TextInput/components/Container.js';
import { Icon } from '../../primitives/TextInput/components/Icon.js';
import { Input } from '../../primitives/TextInput/components/Input.js';
import { Label } from '../../primitives/TextInput/components/Label.js';
import { Wrapper } from '../../primitives/TextInput/components/Wrapper.js';
export const Field = /*#__PURE__*/_styled(forwardRef(function Field({
  id: propsId,
  label,
  message,
  placeholder = ' ',
  name,
  value,
  disabled,
  invalid,
  fullWidth,
  visuallyFocused,
  className,
  appendIcon,
  prependIcon,
  onFocus,
  onBlur,
  size = 'medium',
  variant = 'info',
  allowOverflow,
  type = 'text',
  inputRef: inputRefFromProps = null,
  ...restProps
}, ref) {
  const [focused, setFocused] = useState(false);
  const autoId = useId();
  const id = propsId || autoId;
  const inputRefLocal = useRef(null);
  const inputRef = inputRefFromProps || inputRefLocal;
  const handleFocus = useCallback(event => {
    if (onFocus) {
      onFocus(event);
    }
    setFocused(true);
  }, [onFocus]);
  const handleBlur = useCallback(event => {
    if (onBlur) {
      onBlur(event);
    }
    setFocused(false);
  }, [onBlur]);
  const handleIconClick = useCallback(() => {
    if (!inputRef.current) {
      return;
    }
    if (focused) {
      inputRef.current.blur();
    } else {
      inputRef.current.focus();
    }
  }, [focused, inputRef]);
  return _jsxs(Wrapper, {
    fullWidth: fullWidth,
    ref: ref,
    children: [_jsxs(Container, {
      size: size,
      className: className,
      invalid: invalid,
      disabled: disabled,
      // @ts-expect-error TS(2322) FIXME: Type 'boolean | undefined' is not assignable to ty... Remove this comment to see the full error message
      focused: focused || visuallyFocused,
      variant: variant,
      children: [prependIcon && _jsx(Icon, {
        onClick: handleIconClick,
        size: size,
        "data-testid": "textfield-prepend-icon",
        children: prependIcon
      }), _jsx(Input
      // @ts-expect-error (TS2322) FIXME: Type RefObject<HTMLInputElement | null> is not assignable to type Ref<HTMLInputElement> | undefined>
      , {
        // @ts-expect-error (TS2322) FIXME: Type RefObject<HTMLInputElement | null> is not assignable to type Ref<HTMLInputElement> | undefined>
        ref: inputRef,
        id: id,
        allowOverflow: allowOverflow,
        disabled: disabled,
        name: name,
        placeholder: placeholder,
        value: value,
        size: size,
        onFocus: handleFocus,
        onBlur: handleBlur,
        type: type,
        "aria-label": label,
        "aria-describedby": message ? `${id}-message` : undefined,
        "aria-invalid": invalid,
        ...restProps
      }), placeholder === ' ' && _jsx(Label, {
        tabIndex: -1,
        "data-testid": "label",
        disabled: disabled,
        htmlFor: id,
        children: label
      }), appendIcon && _jsx(Icon, {
        onClick: handleIconClick,
        size: size,
        children: appendIcon
      })]
    }), message && _jsx(Message, {
      "data-testid": "message",
      invalid: invalid,
      id: `${id}-message`,
      children: message
    })]
  });
}), process.env.NODE_ENV === "production" ? {
  target: "e17gdn9f0"
} : {
  target: "e17gdn9f0",
  label: "Field"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");